import Cookies from '../cookies';

const SIGNUP_REDIRECT_STORAGE_KEY = 'sl-signup-redirect';
const HANDOFF_TOKEN_KEY = 'sl-handoff-token';
const COOKIE_UUID = 'sl-user-uuid';
const OLD_COOKIE_UUID = 'sl-user-old-uuid';
const COOKIE_SESSION_ID = 'sl-session-id';
const USER_FLOW = 'sl-user-flow';
const UUID_CHANGE_EVENT_SENT = 'sl-uuid-change-event-sent';
const UK_COUNTRY_COOKIE = 'platgen_uk_country';
const UK_COUNTRY_COOKIE_DAYS = 365;

export function setUuidChangeEventSent(value: boolean) {
  localStorage.setItem(UUID_CHANGE_EVENT_SENT, JSON.stringify(value));
}

export function getUuidChangeEventSent() {
  return JSON.parse(localStorage.getItem(UUID_CHANGE_EVENT_SENT) || 'null');
}

export function setSignupRedirect(url: string): void {
  sessionStorage.setItem(SIGNUP_REDIRECT_STORAGE_KEY, url);
}

export function getSignupRedirect(): string | null {
  return sessionStorage.getItem(SIGNUP_REDIRECT_STORAGE_KEY);
}

export function removeSignupRedirect(): void {
  sessionStorage.removeItem(SIGNUP_REDIRECT_STORAGE_KEY);
}

export function setHandoffToken(token: string): void {
  sessionStorage.setItem(HANDOFF_TOKEN_KEY, token);
}

export function getHandoffToken(): string | null {
  return sessionStorage.getItem(HANDOFF_TOKEN_KEY);
}

export function removeHandoffToken(): void {
  sessionStorage.removeItem(HANDOFF_TOKEN_KEY);
}

export function getDeepLinkIfPresent(): string | null {
  const url = getSignupRedirect();
  return url && url.startsWith('sleepio://') ? url : null;
}

export function setUserFlow(value: string) {
  return Cookies.set(USER_FLOW, value);
}

export function getUserUuid() {
  return Cookies.get(COOKIE_UUID);
}

export function getUserOldUuid() {
  return Cookies.get(OLD_COOKIE_UUID);
}

export function getUserSessionId() {
  return Cookies.get(COOKIE_SESSION_ID);
}

export const UK_VANITY_TO_COUNTRY: Record<string, string> = {
  'nhs-england': 'england',
  'nhs-sleepio': 'scotland',
  wales: 'wales',
  'northern-ireland': 'northern_ireland',
};

export const UK_COUNTRY_TO_VANITY: Record<string, string> = {
  england: 'nhs-england',
  scotland: 'nhs-sleepio',
  wales: 'wales',
  northern_ireland: 'northern-ireland',
};

export function getUserFlowSegments(): string[] {
  const raw = Cookies.get(USER_FLOW);
  if (!raw) {
    return [];
  }
  try {
    return decodeURIComponent(raw).split('/').filter(Boolean);
  } catch (_) {
    return [];
  }
}

export function getUKCountry(): string | null {
  return Cookies.get(UK_COUNTRY_COOKIE) || null;
}

export function setUKCountry(value: string): void {
  Cookies.set(UK_COUNTRY_COOKIE, value, UK_COUNTRY_COOKIE_DAYS);
}

export function clearUKCountry(): void {
  // Cookies.remove() calls set('', -1) which triggers a spurious logError in cookies.js — use document.cookie directly
  document.cookie = `${UK_COUNTRY_COOKIE}=; Max-Age=0; SameSite=Strict; Path=/`;
}
